export const RedirectPage = () => {
    return <h1>Проверьте свою почту</h1>
}